export const PKL_GRP = {
  DISBURSEMENT_FREQUENCY: 10,
  DISBURSEMENT_PAYMENT_TYPE: 11,
  STATUS: 12,
  FACILITY_TYPE: 13,
  KIBOR_RESET_PERIOD: 14,
  LEADS_STATUS: 15,
  TERMS_SECTION: 16,
  LEGAL_STATUS: 17,
  GET_COMPANY: 21,
  COMMON_STATUS: 18,
  RESIDENTIAL_STATUS: 22,
  QUESTION_TYPE: 20,
  QUESTIONNAIRE_SEQ: 3,
  ONBOARDING_STATUS: 23,
  TYPE_OF_NBFCS: 24,
  HIGHLIGHT_TITLE: 27,
  SUMMARY_TITLE: 28,
  INSTITUTIONAL_RATING: 2522,
  PANDDING_STATUS: 26,
  CREDIT_PERPOSAL_EXTRA_TYPE: 30,
  TERMS_PARAMETERS: 31,
  CRDT_PRPSL_GURNTER: 32,
  DISBURSEMENT_STATUS: 33,
  REPATMENTS_TERMS: 34,
  MONITORING_STATUS: 38,
  DEPARTMENT: 39,
  SPECIALIZATION: 40,
  DESIGNATION: 41,
  POSITION: 42,
  QUALIFICATION: 43,
  SUMMARY_TERMS_PARAMETERS: 44,
  CHARGE_TYPE: 45,

  /** Covenant compliance answers (Compliant / Non Compliant / ...). */
  COVENANT_STATUS: 46,

  /** Nationality (Pakistani / Foreigner). */
  NATIONALITY: 48,

  /** Facility Offer Letter statuses (letter and its documents). */
  FOL_STATUS: 50,
} as const;
/**
 * Questionnaires in `/setup/qstnr/*`. The questions and their wording are
 * setup-driven; only which questionnaire a screen reads is fixed here, in one
 * place rather than per component.
 */
export const QSTNR_SEQ = {
  COVENANT: 5,
} as const;

export const MODULE_SEQ = {
  DASHBOARD: 1,

  LEADS: 2,

  ONBOARDING: 3,

  FACILITIES: 4,

  CLIENT: 5,

  DISBURSEMENT: 6,

  REPORTS: 7,

  ADMIN: 8,

  SETUP: 9,

  GL: 10,

  /** Document category (entity type) of a Credit Proposal's supporting documents. */
  CREDIT_PROPOSAL: 12,

  FACILITY_OFFER_LETTER: 13,

  /** Document category (entity type) of a Proposed Disbursement's attachments. */
  PROPOSED_DISBURSEMENT: 14,

  /** Document category of the client's monitoring reports. */
  MONITORING_REPORT: 15,
} as const;

// =============================================
// MODULE NAMES
// =============================================

export const MODULE_NAME = {
  [MODULE_SEQ.DASHBOARD]: 'Dashboard',

  [MODULE_SEQ.LEADS]: 'Leads',

  [MODULE_SEQ.ONBOARDING]: 'Onboarding',

  [MODULE_SEQ.FACILITIES]: 'Facilities',

  [MODULE_SEQ.CLIENT]: 'Client',

  [MODULE_SEQ.DISBURSEMENT]: 'Disbursement',

  [MODULE_SEQ.REPORTS]: 'Reports',

  [MODULE_SEQ.ADMIN]: 'Admin',

  [MODULE_SEQ.SETUP]: 'Setup',

  [MODULE_SEQ.GL]: 'GL',

  [MODULE_SEQ.FACILITY_OFFER_LETTER]: 'Facility Offer Letter',
} as const;

// =============================================
// ENTITY TYPES (approval tasks / review comments)
//
// Note: these are NOT the same numbering as MODULE_SEQ.
// =============================================

export const ENTITY_TYPE = {
  LEADS: 2,
  CREDIT_PROPOSAL: 12,
  ONBOARDING: 3,
  FOL: 13,
  PROPOSED_DSBMT: 14,
} as const;

export const ENTITY_TYPE_NAME: Record<number, string> = {
  [ENTITY_TYPE.CREDIT_PROPOSAL]: 'Credit Proposal',
  [ENTITY_TYPE.FOL]: 'FOL',
  [ENTITY_TYPE.PROPOSED_DSBMT]: 'Proposed Disbursement',
  [ENTITY_TYPE.ONBOARDING]: 'Onboarding',
};

export interface PickListValue {
  tntKey?: number;
  refCdSeq: number; // Unique ID (e.g., 861)
  grpSeq?: number;
  refCd: string; // The code/key (e.g., "861")
  refCdDscr: string; // The display name (e.g., "Family Business")
  sortOrder?: number;
  refCdActvFlg: boolean;
  delFlg?: boolean;
}

export interface PickListMap {
  [groupKey: number]: PickListValue[];
}

export interface DropdownOption {
  label: string;
  value: any;
  original?: PickListValue; // Optional reference to full object
}
